// extracted by mini-css-extract-plugin
export default {"Tool":"ToolId_Tool__c733o","Content":"ToolId_Content__OGfRN","List":"ToolId_List__Rq4ed"};